import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";
import { numberToAvailableDaysMapper } from "utils/constantValues";
import useTime from "hooks/useTime";

function AvailabilityDisplay({
  onEditClick = () => {},
  isShowEditIcon = false,
}) {
  const [t] = useTranslation();
  const { convertToAMPM } = useTime();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);

  return (
    <div
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
    >
      <div className="flex justify-between items-center self-stretch">
        <div className="text-[#1D1B22] font-semibold text-[24px]">
          {t("availabilityTitle")}
        </div>
        {isShowEditIcon && (
          <EditIcon
            className={`cursor-pointer ${
              isEditShowEditOnHover ? "visible" : "invisible"
            }`}
            onClick={onEditClick}
          />
        )}
      </div>

      <div className="flex flex-wrap gap-[10px]">
        {userDetails?.availability?.days?.length > 0 ? (
          userDetails.availability.days.map((dayNum) => {
            return (
              <Fragment key={`${dayNum}`}>
                <div
                  className={`flex py-[6px] px-[10px] justify-center items-center gap-[6px] rounded-[6px] bg-[#E0E6EB]`}
                >
                  <div
                    className={`${
                      isEditShowEditOnHover
                        ? "text-[#1E4A6B]"
                        : "text-[#1D1B22]"
                    } text-[16px] font-semibold text-center`}
                  >
                    {numberToAvailableDaysMapper[dayNum]}
                  </div>
                </div>
              </Fragment>
            );
          })
        ) : (
          <div className="flex text-center items-center justify-center">
            <div className="text-gray-900 font-semibold text-[24px] not-italic w-[90px]">
              {"-"}
            </div>
          </div>
        )}
      </div>
      <div className="flex gap-[24px] flex-wrap self-stretch">
        <LabelComponent
          title={t("timeZone")}
          subTitle={userDetails?.timezone?.name || "-"}
        />

        <LabelComponent
          title={t("Available Time (From/To)")}
          subTitle={`${convertToAMPM(
            userDetails?.availability?.time?.from
          )} - ${convertToAMPM(userDetails?.availability?.time?.to)}`}
        />
      </div>
    </div>
  );
}

AvailabilityDisplay.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default AvailabilityDisplay;
